import * as d3 from "d3";
console.log("System Performance Assessment Show JS loaded");

function initializeSystemPerformanceAssessment() {
    console.log("Initializing System Performance Assessment");

    const viewChromButtons = document.getElementsByClassName("view-chrom-modal-btn");
    Array.from(viewChromButtons).forEach((button) => {
        button.addEventListener("click", function () {
            console.log("View Chromatogram button clicked", this.dataset);


            const analyteName = this.dataset.analyteName;
            const sampleName = this.dataset.sampleName;
            const rowIdx = this.dataset.rowIdx;
            const modal = document.getElementById(`modal-chromatogram-${analyteName}-${sampleName}`);
            console.log("Modal found:", modal);

            // Fetch chromatogram data
            const chromContainer = modal.querySelector('.modal-chromatogram-container');
            // console.log("Chromatogram container:", chromContainer, chromContainer.dataset);
            const rts = JSON.parse(chromContainer.dataset.chromX)
            const intensities = JSON.parse(chromContainer.dataset.chromY)
            const peakIdxs = JSON.parse(chromContainer.dataset.chromApexIdxs)
            console.log("Chromatogram data:", rts.slice(0, 10), intensities.slice(0, 10));

            // Plot using d3
            renderChromatogram(
                {
                    values: rts.map((rt, index) => ({ x: rt, y: intensities[index] })),
                    rmin: 0,
                    rmax: 0,
                    apex_idxs: peakIdxs
                },
                chromContainer,
                "analyte",
                "area_horizontal_raw",
                false,
                sampleName,
                400,
                0
            );
        });
    });
}

// Call initialization immediately when module loads
initializeSystemPerformanceAssessment();

// Export the function so it can be called again if needed
window.initializeSystemPerformanceAssessment = initializeSystemPerformanceAssessment;


// same function modified from the analyse page chromatogram controller
function renderChromatogram(data, targetElement, compoundType, areaToUse, IS_FIA, sampleFilename, graphHeight, sampleSerial) {
    console.log("targetElement from renderChromatogram>>>>>:", targetElement.id);
    console.log("data from renderChromatogram>>>>>:", data);
    let sampleData, sampleIdx, rminIdx, rmaxIdx, rtValues;
    // console.log("TITLES: ", this.EXP_CHROM_TITLE, this.ISTD_CHROM_TITLE, title)
    if (compoundType === "analyte") {
        // console.log("rendering exp chromatogram")
        sampleData = data
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax)

    } else if (compoundType === "istd") {
        // console.log("rendering istd chromatogram")
        sampleData = data
        rminIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmin)
        rmaxIdx = findClosestIndex(sampleData.values.map(d => d.x), sampleData.rmax)
    }
    rtValues = sampleData.values.slice(rminIdx, rmaxIdx + 1)
    // console.log(">> rminIdx, rmin", rminIdx, sampleData.values[rminIdx], sampleData.rmin)
    // console.log("rmaxIdx, rmax", rmaxIdx, sampleData.values[rmaxIdx], sampleData.rmax)
    // console.log("data from renderChromatogram: ", data)
    let colors = {
        exp: {
            fill: ['rgba(220, 38, 38, 0.25)'],
            stroke: ['#dc2626'],
        },
        istd: {
            fill: ['rgba(22, 163, 74, 0.25)'],
            stroke: ['#16a34a'],
        },
    }
    let fillColors = ["transparent", "#ffffff", compoundType === "analyte" ? colors.exp.fill[0] : colors.istd.fill[0]]
    sampleFilename = sampleFilename.split('_').slice(5, -1).join('_')
    if (rminIdx > -1 && rmaxIdx > -1) {  // this means that the retention time window has been set
        let zoomedData = sampleData.values
        zoomedData = zoomedData.sort((a, b) => a.x - b.x).filter((d) => sampleData.values[rminIdx]['x'] - d.x < this.CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER && d.x - sampleData.values[rmaxIdx]['x'] < this.CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER)
    } else if (rminIdx === rmaxIdx) {  // this means that the retention time window has not been set by backend (due to failure of peak picking), is usually just the first point
    } else {  // if any othe errors occur, just plot the entire chromatogram
    }
    let xValues = sampleData.values.map(d => d['x']);
    let yValues = sampleData.values.map(d => d['y']);
    console.log("xValues and yValues", xValues, yValues);
    window.xValues = xValues;
    window.yValues = yValues;
    // console.log("AREATOUSE", areaToUse)
    // console.log("AREATOUSE sampleData.values[rminIdx], sampleData.values[rmaxIdx]", sampleData.values[rminIdx], sampleData.values[rmaxIdx])
    // console.log("AREATOUSE rminIdx, rmaxIdx", rminIdx, rmaxIdx)

    // Find the maximum and minimum values of 'x'
    let maxX = Math.max(...xValues) + 0.005 * Math.max(...xValues);
    let minX = Math.min(...xValues) - 0.005 * Math.max(...xValues);
    let maxY = Math.max(...yValues) + 0.025 * Math.max(...yValues);
    let maxRTY = -Infinity; // Initialize maxRTY to a very small number
    let maxRTX = null; // Initialize maxRTX to null
    let xRTExtent = d3.extent(rtValues, d => d.x)
    let yRTExtent = d3.extent(rtValues, d => d.y)

    // Iterate through the list of dictionaries
    rtValues.forEach(dict => {
        // Check if the 'y' value of the current dictionary is greater than the current maxRTY
        if (dict.y > maxRTY) {
            // If it is, update maxRTY and maxRTX
            maxRTY = dict.y;
            maxRTX = dict.x;
        }
    });
    console.log("MAX RT Y AND X", maxRTY, maxRTX)
    let minY = 0;
    // Default to rmin and rmax
    let newrminIdx = rminIdx;
    let newrmaxIdx = rmaxIdx;
    console.log("MIN", newrminIdx)
    console.log("MAX", newrmaxIdx)
    // console.log("Max X: ", maxX)
    // console.log("Min X: ", minX)
    // console.log("Max Y: ", maxY)
    // Declare the chart dimensions and margins.
    const width = 1248;
    const height = graphHeight
    const padding = { top: 50, bottom: 70, left: 90, right: 30 }
    // Calculate the slope (m) and intercept (b) of the line connecting the two points
    // let m, b;
    // if (sampleData.values.length > 0) {
    //     m = (sampleData.values[rmaxIdx].y - sampleData.values[rminIdx].y) / (sampleData.values[rmaxIdx].x - sampleData.values[rminIdx].x);
    //     b = sampleData.values[rminIdx].y - m * sampleData.values[rminIdx].x;
    // }
    // Declare the x (horizontal position) scale. 
    const xRT = [xRTExtent[0] - this.CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER, xRTExtent[1] + this.CHROMATOGRAM_RETENTION_TIME_WINDOW_BUFFER]
    const x = d3.scaleLinear(rminIdx == rmaxIdx ? [minX, maxX] : xRT, [0, width]);
    let x2 = x.copy();

    // Declare the y (vertical position) scale.
    const y = d3.scaleLinear([0, rminIdx == rmaxIdx ? maxY : yRTExtent[1] * 1.025], [height, 0]);
    let y2 = y.copy();
    let selectionExtent = [-1, -1];

    // Declare the line generator.
    const line = d3.line()
        .x(d => x2(d.x))
        .y(d => y2(d.y));

    // Declare the area generator.
    // Area spans to y == 0 when area to integrate is vertical or is FIA panel
    // const area = d3.area()
    //     .x(d => x2(d.x))
    //     .y0(d => {
    //         return (areaToUse == "area_vertical_raw" || IS_FIA) ?  y2(0) : y2(Math.min(d.y, m * d.x + b))
    //     })
    //     .y1(d => y2(d.y)); 

    // const whiteArea = d3.area()
    //     .x(d => x2(d.x))
    //     .y0(y2(0))
    //     .y1(d => {
    //         return (areaToUse == "area_vertical_raw" || IS_FIA) ? y2(0) : y2(m * d.x + b) 
    //     })

    // Create the SVG container.
    const svg = d3.select(targetElement)
        .attr("width", "100%")
        .attr("height", height)
        .attr("viewBox", [0, 0, width + padding.right + padding.left, height + padding.top + padding.bottom])
        .attr("style", "max-width: 100%; height: auto;")


    svg.selectAll("*").remove();

    const plotArea = svg.append("g")
        .attr("transform", "translate(" + [padding.left, padding.top] + ")")

    const clippingRect = plotArea
        .append("clipPath")
        .attr("id", "clippy")
        .append("rect")
        .attr("width", width)
        .attr("height", height)
        .attr("fill", "none")

    // // Append a path for the area (under the axes).
    // const areaPath = plotArea.append("path")
    //     .attr("fill", compoundType === "analyte" ? colors.exp.fill[0] : colors.istd.fill[0])
    //     .attr("d", area(rtValues))
    //     .attr("clip-path","url(#clippy)");

    // // Append a path for the area (under the axes).
    // const whiteAreaPath = plotArea.append("path")
    //     .attr("fill", "white")
    //     .attr("d", whiteArea(rtValues))
    //     .attr("clip-path","url(#clippy)");

    // Append a path for the line.
    const linePath = plotArea.append("path")
        .attr("stroke", compoundType === "analyte" ? colors.exp.stroke[0] : colors.istd.stroke[0])
        .attr("stroke-width", 2) // Set the stroke width
        .attr("fill", "none")
        .attr("d", line(sampleData.values))
        .attr("clip-path", "url(#clippy)");

    // Brushing
    let controller = this
    let newRmin, newRmax;
    const brush = d3.brushX()
        .on('brush end', function (event) {
            const selection = event.selection;
            let value = [];
            // Check if there's a selection
            if (selection) {
                // Convert pixel coordinates to data values
                const x0 = x2.invert(selection[0]);
                const x1 = x2.invert(selection[1]);
                console.log("VALUES", x0, x1)

                value = dataPoints
                    .style("fill", "yellow")
                    .filter((d) => x0 <= d.x && d.x <= x1)
                    .style("fill", "blue")
                    .data();
                console.log("value", value)
                if (value.length != 0) {
                    newRmin = value[0].x
                    newRmax = value[value.length - 1].x
                    newrminIdx = sampleData.values.findIndex(d => d.x === value[0].x)
                    newrmaxIdx = sampleData.values.findIndex(d => d.x === value[value.length - 1].x)
                    // console.log(newrminIdx, newrmaxIdx)
                    console.log("SERIAL", sampleSerial)
                    controller.MULTI_SAMPLE_LIST[sampleSerial][compoundType]["newRmin"] = newRmin
                    controller.MULTI_SAMPLE_LIST[sampleSerial][compoundType]["newRmax"] = newRmax
                    console.log("MULTI_SAMPLE_LIST", controller.MULTI_SAMPLE_LIST, newRmin, newRmax)
                    selectionExtent = [x0, x1];
                }

                // update the feedback text
                $(targetElement).parent().parent().find(`.${compoundType}-feedback`).find(".new-rt").text(`${newRmin ? parseFloat(newRmin).toFixed(2) : ''}, ${newRmax ? parseFloat(newRmax).toFixed(2) : ''}`)

            }
            else {
                selectionExtent = [-1, -1];
                dataPoints.style("fill", "yellow");
                this.newrminIdx = this.rminIdx
                this.newrmaxIdx = this.rmaxIdx
            }
            // Inform downstream cells that the selection has changed.
            svg.property("value", value).dispatch("input");

        });

    plotArea.call(brush)

    // // create a tooltip
    // const tooltipDiv = d3.select(targetElement.parentElement)
    //     .append("div")
    //     .classed("tooltip", true)
    // console.log("TOOLTIP", tooltipDiv)
    // var tooltip = new Tooltip(tooltipDiv);
    var Tooltip = d3.select(targetElement.parentElement)
        .append("div")
        .style("opacity", 0)
        .attr("class", "d3-chart-tooltip shadow")
        .style("position", "fixed")
        .style("background-color", "rgba(255, 243, 205, 0.75)") // Set the background color with opacity
        .style("border", "dashed")
        .style("border-width", "1px")
        .style("border-radius", "5px")
        .style("padding", "5px")
        .style("pointer-events", "none")
        .style("z-index", "9999")

    // Three function that change the tooltip when user hover / move / leave a cell
    var mouseover = function (d) {
        Tooltip
            .style("opacity", 1)
    }
    var mousemove = function (d, event) {
        // CSS zoom: 0.8 on body means fixed-position CSS values are scaled.
        // Divide clientX/Y by zoom so the tooltip lands at the cursor.
        const zoomLevel = parseFloat(getComputedStyle(document.body).zoom) || 1;
        Tooltip
            .html(`<div class="fs-5"><b>Intensity:</b> ${event.y.toExponential(2)}<br> <b>Time:</b> ${event.x.toFixed(2)} minutes</div>`)
            .style("left", (d.clientX / zoomLevel + 5) + "px")
            .style("top", (d.clientY / zoomLevel - 60) + "px")
    }
    var mouseleave = function (d) {
        Tooltip
            .style("opacity", 0)
    }

    // Plot data points
    const dataPoints = plotArea.append("g")
        .selectAll("circle")
        .data(sampleData.values)
        .join("circle")
        .attr("cx", d => x2(d.x))
        .attr("cy", d => y2(d.y))
        .attr("r", 6) // Adjust the radius as needed
        .attr("fill", "yellow")
        .attr("stroke", "black")
        .attr("stroke-width", 1)
        .attr("clip-path", "url(#clippy)")
        .style('pointer-events', 'all')
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave)


    // function that sets the tooltip's HTML when revealed
    // can be passed the hovered selection's datum
    function tooltipContents(d) {
        return `Time (mins): ${d.x}, Intensity: ${d.y}`;
    }

    // Add the x-axis.
    const xAxis = d3.axisBottom(x2);
    const gx = plotArea.append("g")
        .attr("transform", `translate(0,${height})`)
        .call(xAxis.ticks(10).tickSizeOuter(0))
        .call(g => g.append("text")
            .attr("x", width / 2)
            .attr("y", padding.bottom / 1.2)
            .attr("fill", "currentColor")
            .attr("text-anchor", "middle")
            .text("Retention Time (mins)"))
        .style("font-size", "min(3em, 24px)");
    // console.log("width / 2: ", width / 2)

    // Add the y-axis, remove the domain line, add grid lines and a label.
    const yAxis = d3.axisLeft(y2);
    const gy = plotArea.append("g")
        .attr("transform", `translate(${padding.left / 25}, 0)`)
        // .call(yAxis.tickValues(y2.ticks(this.MULTI_SAMPLE ? 2 : 5)).tickFormat(d3.format(".1e")))
        .call(yAxis.ticks(this.MULTI_SAMPLE | this.MULTI_SAMPLE_PAGE ? 2 : 5).tickFormat(d3.format(".1e")))
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll(".tick line").clone()
            .attr("x2", width)
            .attr("stroke-opacity", 0.1))
        .style("font-size", "min(3em, 24px)")
        .call(g => g.append("text")
            .attr("x", 0)
            .attr("y", -padding.top / 4)
            .attr("fill", "currentColor")
            .attr("text-anchor", "start")
            .text(`Intensity`))

    // Check if data is available
    if (sampleData.values.length === 0) {
        // No data available, display a message or placeholder
        svg.append("text")
            .attr("transform", "translate(" + [width / 2 - padding.right, height / 2] + ")")
            .attr("fill", "currentColor")
            .text("No Data Found")
            .style("font-size", "min(5em, 32px)");
    }


    // const brushArea = svg.append('g')
    // .attr("transform", "translate("+[padding.left, padding.top]+")")




    function zoomed(event) {
        const t = event.transform;
        if (t.k <= 0.95) {
            x.domain([minX, maxX])
            y.domain([0, maxY])
        }
        x2 = t.rescaleX(x);
        y2 = t.rescaleY(y);

        // Redraw scales
        gx.call(xAxis.scale(x2))
        gy.call(yAxis.scale(y2))
            .call(g => g.select(".domain").remove())
        gy.selectAll(".tick line")
            .attr("x2", width)
            .attr("stroke-opacity", 0.1);

        // Redraw paths
        linePath.attr("d", line(sampleData.values))
        // areaPath.attr("d", area(rtValues, x2, y2))
        // whiteAreaPath.attr("d", whiteArea(rtValues, x2, y2))
        dataPoints.attr("cx", d => x2(d.x)).attr("cy", d => y2(d.y))

        // Redraw selection
        if (selectionExtent[0] !== -1 && selectionExtent[1] !== -1) {
            // get the brush's x0/x1
            const [x0, x1] = selectionExtent.map(x);
            // rescale the coordinates to the new scale
            const _x0 = x0 * t.k + t.x;
            const _x1 = x1 * t.k + t.x;

            // move the brush
            brush.move(plotArea, [_x0, _x1]); // update brush extent
        }

    }

    const zoom = d3.zoom()
        .scaleExtent([0.95, 64])
        .extent([[-padding.left, -padding.top], [width + padding.right, height]])
        .translateExtent([
            [-padding.left, -padding.top],
            [width + padding.right, height]
        ])
        .on("zoom", zoomed)
        .wheelDelta(customWheelDelta)
        .filter(function (event) {
            return (event.button === 0 && event.ctrlKey)  // || event.type === "wheel";
        })

    function customWheelDelta(event) {
        return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002);
    }
    // const zoomArea = plotArea.append('rect')
    //     .attr('width', width)
    //     .attr('height', height)
    //     .style('fill', 'none')
    //     .style('pointer-events', 'all');

    // // Disables context on right click 
    // svg.on("contextmenu", function (event) {
    //     console.log("RIGHT CLICK")
    //     // Prevent the default context menu
    //     event.preventDefault();
    // });

    svg.call(zoom)
        .on("dblclick.zoom", function () {
            // Replace double click zoom to reset zoom
            svg.call(zoom.transform, d3.zoomIdentity)
        })
    console.log("IDENTITY", d3.zoomIdentity)
    svg.call(zoom.transform, d3.zoomIdentity)

    // Set up the initial zoom transformation to focus on the portion of points
    // let scale = maxY / maxRTY;
    // let initialTransform = d3.zoomIdentity
    //     .translate(-x(xRTExtent[0]) - padding.left, -y(yRTExtent[0]) - padding.top) // Translate to the top-left corner of the portion
    //     .scale(1 / Math.max((x(xRTExtent[1]) - x(xRTExtent[0])) / width, (y(yRTExtent[1]) - y(yRTExtent[0])) / height)); // Scale to fit the portion within the viewport

    // Apply the initial zoom transformation to the SVG element
    // svg.call(zoom.transform, initialTransform);

    // add y = apex idx lines
    const apexInfo = Object.entries(data.apex_idxs).map(([analyte_name, apex_idx]) => {
        apex_idx = parseInt(apex_idx)
        return {
            analyte_name: analyte_name,
            apex_idx: apex_idx,
            x1: xValues[apex_idx],
            y1: 0,
            x2: xValues[apex_idx],
            y2: yValues[apex_idx]
        }
    })
    console.log("APEX INFO", apexInfo)

    // draw vertical line on the X axis using x1, y1, and x2, y2 using brush
    plotArea.selectAll(".apex-line")
        .data(apexInfo)
        .enter()
        .append("line")
        .attr("class", "apex-line")
        .attr("x1", d => x2(d.x1))
        .attr("y1", d => y2(d.y1))
        .attr("x2", d => x2(d.x2))
        .attr("y2", d => y2(d.y2))
        .attr("stroke", "green")
        .attr("stroke-width", 1)
        .attr("stroke-dasharray", "4")
        .attr("clip-path", "url(#clippy)")
        .append("title")
        .text(d => `Apex of ${d.analyte_name} at RT: ${d.x1.toFixed(2)} mins, Intensity: ${d.y2.toExponential(2)}`);






    return svg.node();
}


function findClosestIndex(array, target) {
    if (array.length === 0) return -1
    let closestIdx = 0
    let closestDiff = Math.abs(target - array[0])
    for (let i = 1; i < array.length; i++) {
        let diff = Math.abs(target - array[i])
        if (diff < closestDiff) {
            closestIdx = i
            closestDiff = diff
        }
    }
    return closestIdx
}